export default "__VITE_ASSET__C4Y_oHTT__"